import * as React from 'react'

import { Box, Container, Link, Stack, Text } from '@chakra-ui/react'

import Headroom from 'react-headroom'
import { IconPhone } from '@tabler/icons';

export const Banner = () => (
  <Headroom
  // style={{marginTop:`-40px!important;`}}
  // wrapperStyle={{ marginTop: `-40px` }}
  >
  <Box as="section">
    <Box bg="blue.600" color="on-accent" position="relative">
      <Container py="8px">
        <Stack
          direction={{ base: 'column', sm: 'row' }}
            justify="center"
            alignItems="center"
            spacing={{ base: '0.5', md: '1.5' }}
            pe={{ base: '4', sm: '0' }}
          >
            <Stack direction="row" justify="center">
              <IconPhone color="transparent" fill="white" stroke="none" strokeWidth="none" ></IconPhone>
              <Text fontSize="md" fontWeight="medium" color="white" >Call our Customer Service  </Text>
            </Stack>
          <Link color="white" href="tel:+1 855 564-1492" fontWeight="bold"> +1 855 564-1492 </Link>  
        </Stack>
      </Container>
    </Box>
  </Box>

  </Headroom>
)